class L.MassEvents
    constructor: () ->
        @__events = []
    # Given an array of arrays, .on will attach the specified events to trigger
    # the specified callback
    #
    # example:
    #   objectevents = [
    #       [App.map,['draw:created','draw:point-edited']]
    #       [toolbar,['button-clicked']]
    #   ]
    #
    #   cb = (event) ->
    #       console.log event
    #
    #   When App.map fires 'draw:created' or 'draw:point-edited', or toolbar fires 'button-clicked',
    #   cb will be called
    on: (objectevents, cb) ->
        self = this

        List.map (i) ->
            if not $.isArray(i[1])
                self.attach i[0], i[1], cb
                #i[0].on i[1],cb
            else
                List.map (e) ->
                    self.attach i[0], e, cb
                    #i[0].on e,cb
                , i[1]

        , objectevents


    attach: (source, event, cb) =>
        source.on event, cb
        @__events.push { 'source': source, 'event': event, 'cb': cb }



    detach: (source, event, cb, del = true) =>
        source.off event, cb

        if del
            for i, j in @__events
                if i.source is source and i.event is event and i.cb is cb
                    @__events.splice(j, 1)
                    return


    destroy: () ->
        for i, j in @__events
            if i?
                @detach i.source,  i.event, i.cb, false
            delete @__events[j]


    # Following the same form as above, event listeners can be removed
    # from multiple objects
    off: (objectevents, cb) ->
        self = this

        List.map (i) ->
            if not $.isArray(i[1])
                self.detach i[0], i[1], cb
                #i[0].off i[1],cb
            else
                List.map (e) ->
                    self.detach i[0], e, cb
                    #i[0].off e,cb
                , i[1]

        , objectevents
